<template>
  <Card>
    <template slot="title">
      <Breadcrumb>
        <BreadcrumbItem to="/wareList">仓库信息</BreadcrumbItem>
        <BreadcrumbItem>{{ detail ? detail.wmsName : "" }}</BreadcrumbItem>
      </Breadcrumb>
    </template>
    <template slot="extra">
      <Button type="primary" icon="md-globe" @click="action(1)"
        >发货区域</Button
      >
      <Button type="primary" icon="md-globe" @click="action(-1)"
        >发货渠道</Button
      >
      <Button type="primary" icon="md-swap" @click="action(2)"
        >同步资金商商品</Button
      >
      <Button type="primary" icon="ios-create" @click="saveData">提交</Button>
      <Button type="primary" icon="ios-undo" @click="action(4)">返回</Button>
    </template>
    <table>
      <tr>
        <th colspan="7">仓库基础信息</th>
      </tr>
      <tr>
        <th>编号</th>
        <td>{{ detail.wmsCode }}</td>
        <th>资金商</th>
        <td>{{ detail.spName }}</td>
        <th>仓库名称</th>
        <td>{{ detail.wmsName }}</td>
      </tr>
      <tr>
        <th>送达方编码</th>
        <td>{{ detail.shipToCode }}</td>
        <th>送达方名称</th>
        <td>{{ detail.shipToName }}</td>
        <th>资金商编码</th>
        <td colspan="3">{{ detail.spCode }}</td>
      </tr>
      <tr v-if="detail.wmsAddressInfo">
        <th>仓库地址</th>
        <td colspan="5">
          {{
            detail.wmsAddressInfo.provinceName +
            "省" +
            detail.wmsAddressInfo.cityName +
            detail.wmsAddressInfo.countyName +
            detail.wmsAddressInfo.streetName +
            detail.wmsAddressInfo.address
          }}
        </td>
        <!-- <th>备注</th>
        <td colspan="5">{{ detail.remark }}</td> -->
      </tr>
    </table>
    <table>
      <tr>
        <th colspan="7">仓库覆盖区域</th>
      </tr>
      <tr>
        <th>省</th>
        <th>市</th>
        <th>区</th>
      </tr>
      <tr>
        <td>{{ areaData.province.toString() }}</td>
        <td>{{ areaData.city.toString() }}</td>
        <td>{{ areaData.area.toString() }}</td>
      </tr>
    </table>
    <Table
      :style="{ marginTop: '10px' }"
      border
      stripe
      :columns="columns"
      :data="channelMap"
    >
      <template slot-scope="{ row, index }" slot="sort">
        <span v-show="false">{{ row.code }}</span>
        {{ (page - 1) * pageSize + index + 1 }}
      </template>
    </Table>
    <Modal v-model="modal1" title="发货区域" @on-ok="ok">
      <Input
        v-model="provinceName"
        placeholder="请输入省份名称"
        class="public-inp"
      />
      <Button
        class="public-fr"
        type="primary"
        icon="ios-search"
        @click="searchArea()"
        >查询</Button
      >
      <Button class="public-fr" type="primary" @click="resetTree">重置</Button>
      <Tree ref="tree1" :data="areaTree" show-checkbox></Tree>
    </Modal>
    <Modal v-model="modalChannel" title="发货渠道">
      <Card
        v-for="(item, index) in sourceList"
        :key="index"
        style="margin-bottom: 20px"
      >
        <p slot="title">
          <Icon type="ios-menu-outline"></Icon>
          仓库渠道{{ index + 1 }}
        </p>
        <div slot="extra">
          <Button type="text" @click="addSourceList">添加</Button>
          <Button
            v-if="sourceList.length > 1"
            type="text"
            @click="delSourceList(index)"
            >删除
          </Button>
        </div>
        <Row>
          <Col span="8">
            <Select
              v-model="item.areaCode"
              :label-in-value="true"
              style="width: 70%"
              placeholder="请选择省份"
              @on-change="(value) => selectChange(value, index)"
            >
              <Option
                v-for="item in combaseAreaAll"
                :key="item.areaCode"
                :value="item.areaCode"
                :disabled="item.disabled"
                >{{ item.areaName }}
              </Option>
            </Select>
          </Col>
          <Col span="8">
            <Select
              v-model="item.channelCodeList"
              multiple
              style="width: 120%"
              placeholder="请选择渠道，支持多选"
            >
              <Option v-for="item in baseChannelList" :value="item" :key="item"
                >{{ item }}
              </Option>
            </Select>
          </Col>
        </Row>
      </Card>
      <div slot="footer">
        <Button type="text" size="large" @click="cancel">取消</Button>
        <Button type="primary" size="large" @click="updateWareChannel"
          >确定</Button
        >
      </div>
    </Modal>
  </Card>
</template>
<script>
export default {
  data() {
    return {
      name: "详情",
      detail: {},
      areaData: {
        province: [],
        city: [],
        area: [],
      },
      areaDataKey: {
        province: [],
        city: [],
        area: [],
      },
      modal1: false,
      modalChannel: false,
      areaTree: [],
      sourceList: [
        {
          areaCode: "",
          areaName: "",
          channelCodeList: [],
          shipToCode: "",
          wmsCode: "",
        },
      ],
      columns: [
        {
          title: "省份",
          key: "areaName",
        },
        {
          title: "渠道",
          key: "channelCodeList",
        },
      ],
      channelMap: [],
      baseChannelList: [],
      baseAreaAll: [],
      provinceName: "",
      originData: [],
      loading: true,
    };
  },
  computed: {
    combaseAreaAll() {
      return this.baseAreaAll.map((item) => {
        return {
          ...item,
          disabled:
            item.disabled ||
            this.sourceList.some((item0) => item0.areaCode == item.areaCode),
        };
      });
    },
  },
  watch: {},
  created() {
    this.getDetail();
    this.getArea();
    this.getBaseChannelList();
    this.getBaseAreaAll();
    this.getChannelMap();
  },
  methods: {
    getChannelMap() {
      let shipToCode = this.$route.query.shipToCode;
      let wmsCode = this.$route.query.wmsCode;
      let params = {
        wmsCode: wmsCode,
        shipToCode: shipToCode,
      };
      this.$api.queryChannelList(params).then((res) => {
        if (res.code == "200") {
          this.channelMap = res.data;
        }
      });
    },
    getBaseChannelList() {
      this.$api.baseChannel().then((res) => {
        if (res.code == "200") {
          this.baseChannelList = res.data;
        }
      });
    },
    getBaseAreaAll() {
      let shipToCode = this.$route.query.shipToCode;
      let wmsCode = this.$route.query.wmsCode;
      let params = {
        wmsCode: wmsCode,
        shipToCode: shipToCode,
      };

      this.$api.queryProvinceArea(params).then((res) => {
        if (res.code == "200") {
          this.baseAreaAll = res.data;
        }
      });
    },
    addSourceList() {
      this.sourceList.push({
        areaCode: "",
        areaName: "",
        channelCodeList: [],
        shipToCode: this.$route.query.shipToCode,
        wmsCode: this.$route.query.wmsCode,
      });
    },
    delSourceList(index) {
      this.sourceList.splice(index, 1);
    },
    selectChange(value, sourceIndex) {
      if (value) {
        this.$set(this.sourceList[sourceIndex], "areaCode", value.value || "");
        this.$set(this.sourceList[sourceIndex], "areaName", value.label || "");
      }
    },
    getDetail() {
      let data = this.$route.query;
      this.$api["wareDetail"](data).then((res) => {
        if (res.code == "200") {
          this.detail = res.data;
        }
      });
    },
    getArea() {
      let data = this.$route.query;
      this.$api["wareSearchArea"](data).then((res) => {
        if (res.code == "200") {
          let list = this.tools.treeToArray(res.data);
          let m = new Map();
          m.set(2, "province");
          m.set(3, "city");
          m.set(4, "area");
          list.forEach((e) => {
            let key = m.get(e.level);
            this.areaData[key].push(e.name);
            this.areaDataKey[key].push(e.code);
          });
        }
      });
    },
    action(t) {
      let d = this.detail;
      let query = {
        shipToCode: d.shipToCode,
        spCode: d.spCode,
        wmsCode: d.wmsCode,
      };
      switch (t) {
        case -1: {
          if (this.channelMap.length == 0) {
            this.$Message.error("请先设置仓库发货区域");
            return false;
          }
          this.$nextTick(() => {
            this.provinceName = "";
            this.modalChannel = true;
            this.getBaseAreaAll();
            this.getBaseChannelList();
            // 回显已配置数据
            let channelMap = this.channelMap;
            let no_index = [];
            channelMap.map((item, index) => {
              let flag = item.channelCodeList ? true : false;
              if (!flag) no_index.push(index);
            });
            var flag_m = channelMap.some((item) => {
              return item.channelCodeList ? true : false;
            });
            if (flag_m) {
              this.sourceList = JSON.parse(JSON.stringify(this.channelMap));
              no_index.forEach((i0) => {
                this.sourceList.splice(i0, 1);
              });
            } else {
              this.sourceList[0].wmsCode = this.$route.query.wmsCode;
              this.sourceList[0].shipToCode = this.$route.query.shipToCode;
            }
          });
          break;
        }
        case 1:
          this.getAreaTree(); 
          this.$nextTick(() => {
            this.modal1 = true;
          });
          break;
        case 2:
          this.setSwap(query);
          break;
        case 3:
          this.$router.replace({ path: "/wareAdd", query });
          break;
        default:
          this.$router.replace({ path: "/wareList" });
      }
    },
    getAreaTree() {
      return new Promise((reslove) => {
        let spCode = this.detail.spCode;
        this.$api["spAreaSearch"]({ spCode }).then((res) => {
          if (res.code == "200") {
            let list = res.data;
            if (list && list.length > 0) {
              this.areaTree = this.getArray(list);
              this.originData = this.getArray(list);
            }
          }
        });
      });
    },
    getArray(data) {
      //参数data:要格式化的数据
      let areaData = this.areaDataKey;
      var trees = new Array();
      var fn;
      for (var i in data) {
        var newData = {
          ...data[i],
          title: data[i].name,
          expand: false,
          selected: data[i].checkFlag,
          children: [],
        };
        areaData.area.map((i2) => {
          if (i2 == data[i].code) {
            if (newData.level == 4) {
              newData.checked = true;
            }
          }
        });
        trees.push(newData);
        if (data[i]["children"]) {
          fn = this.getArray(data[i]["children"]);
          trees[i].children = fn;
        }
      }
      newData = null;
      fn = null;
      return trees;
    },
    ok() {
      let d = this.detail;
      let l = this.$refs["tree1"].getCheckedNodes();
      let all = this.$refs["tree1"].getCheckedAndIndeterminateNodes();
      let list = l.map((item) => {
        return item.code;
      });
      let data = {
        shipToCode: d.shipToCode,
        spCode: d.spCode,
        wmsCode: d.wmsCode,
        areaCodeList: list,
      };
      // 重置数据
      this.areaData = {
        province: [],
        city: [],
        area: [],
      };
      this.areaDataKey = {
        province: [],
        city: [],
        area: [],
      };
      this.$api["wareUpdateArea"](data).then((res) => {
        if (res.code == "200") {
          this.$Message.success("设置成功");
          this.getArea();
          this.getAreaTree();
          this.getChannelMap();
          this.getDetail();
        }
      });
    },
    cancel() {
      this.modalChannel = false;
    },
    updateWareChannel() {
      var can_click = false;
      this.sourceList.forEach((item) => {
        if (item.areaCode == "") {
          this.$Message.error("省份不能为空");
          can_click = false;
        } else if (!item.channelCodeList || item.channelCodeList.length == 0) {
          this.$Message.error("渠道不能为空");
          can_click = false;
        } else {
          can_click = true;
        }
      });

      if (can_click) {
        this.$api.batchUpdateChannel(this.sourceList).then((res) => {
          if (res.code == "200") {
            this.$Message.success("设置成功");
            this.getChannelMap();
            this.modalChannel = false;
            this.getDetail()
          }
        });
      }
    },
    setSwap(d) {
      this.$api["wareSync"](d).then((res) => {
        if (res.code == "200") {
          this.$Message.success("同步成功");
          this.getDetail()
        }
      });
    },
    resetTree() {
      this.provinceName = "";
      this.getAreaTree();
    },
    searchArea() {
      let list = this.originData;
      if (this.provinceName) {
        let new_list = list.filter((item) => {
          return item.name.indexOf(this.provinceName) > -1;
        });
        this.areaTree = new_list;
      }
    },

    saveData() {
      if (
        this.areaData.area.length == 0 &&
        this.areaData.city.length == 0 &&
        this.areaData.province.length == 0
      ) {
        this.$Message.error("发货区域未设置");
        return false;
      }
      if (this.channelMap.length > 0) {
        if (
          this.detail.settingFlag == 1 &&
          this.channelMap.some((item) => {
            if (!item.channelCodeList) {
              this.$Message.error("发货渠道未设置");
              return false;
            } else {
              return true;
            }
          })
        ) {
          let detail = this.detail;
          // 待配置状态更新至启用状态
          if (detail.status == 0) {
            let params = {
              shipToCode: detail.shipToCode,
              spCode: detail.spCode,
              wmsCode: detail.wmsCode,
            };
            this.$api.wareEnable(params).then((res) => {
              if (res.code == "200") {
                this.$Message.success("保存成功");
              }
            });
          }
        }
      }
    },
  },
};
</script>
<style scoped>
table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
}

th,
td {
  padding: 0 10px;
  text-align: center;
  border: 1px solid #dcdee2;
  line-height: 30px;
  color: #515a6e;
  font-size: 12px;
}

th {
  background: #f8f8f9;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/wareDetail.vue